<template>
  <v-card color="transparent" flat tile>
    <v-card-title class="justify-center">
      <h1 class="grey--text text--darken-4">Astuces de codeur <i class="fas fa-id-card"></i></h1>
    </v-card-title>
    <v-tabs dark color="grey darken-4" background-color="blue-grey lighten-2" v-model="activeItem">
      <v-tab v-for="(item, index) in items" :class="activeItem!=index ? 'blue-grey--text text--darken-2' : ''" :key="'tab-'+index" @click="activeItem=index">{{ item.label }}</v-tab>
    </v-tabs>
    <v-window v-model="activeItem">
      <v-window-item v-for="(item, index) in items" :value="index" :key="index">
        <v-row>
          <v-col cols="1"></v-col>
          <v-col cols="10">  
            <v-card color="transparent" class="fill-height pb-5" flat tile>
                <v-card-title class="justify-center grey--text text--darken-4">{{ item.label }}</v-card-title>
                <v-expansion-panels popout focusable>
                  <v-expansion-panel v-for="(tip, i) in item.values" :key="item.label+'-'+i" class="blue-grey lighten-5">
                    <v-expansion-panel-header class="font-weight-bold blue-grey--text text--darken-4 blue-grey lighten-4" v-html="tip.title"></v-expansion-panel-header>
                    <v-expansion-panel-content class="mt-3">
                      <center>
                      <blockquote class="text-left">
                        <p v-html="tip.value"></p>
                      </blockquote>
                      </center>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </v-window-item>
    </v-window>
    <v-card-actions class="justify-space-between">
      <v-btn text @click="activeItem--" :disabled="(activeItem==0)">
        <v-icon>fa-chevron-left</v-icon>
      </v-btn>
      <v-item-group v-model="activeItem" class="text-center" mandatory>
        <v-item v-for="(item, n) in items" :key="`btn-${n}`" v-slot="{ active, toggle }">
          <v-btn :input-value="active" icon @click="toggle">
            <v-icon>fa-circle</v-icon>
          </v-btn>
        </v-item>
      </v-item-group>
      <v-btn text @click="activeItem++" :disabled="(activeItem==items.length-1)">
        <v-icon>fa-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'Tips',
  components: {
  },
  data: () => ({
    activeItem: 0,
    items: [
      {
        label: 'MySQL',
        values: [
          { title: 'Taille d\'une table en Mo (via information_schema)', value: 'SELECT table_name AS "Table", ROUND(((data_length + index_length) / 1024 / 1024), 2) "Taille (Mo)" <br/>FROM information_schema.TABLES </br>WHERE table_schema = "%s" AND table_name = "%s"' },
          { title: 'Calcul de l\'age', value: 'TIMESTAMPDIFF(YEAR,birthdate,CURDATE()) AS age' },
          { title: 'Tri d\'une colonne selon un ordre défini', value: 'ORDER BY FIELD(Country, "France", "Belgium", "Spain", "Italy")' },
          { title: 'Blob non vide', value: 'WHERE OCTET_LENGTH(content)>0' },
          { title: 'Exporter une table avec mysqldump', value: 'mysqldump -h127.0.0.1 -uroot -p mydatabase mytable > /var/tmp/table.sql' },
          { title: 'Charger un fichier', value: 'LOAD DATA LOCAL INFILE "/tmp/import.sql" INTO TABLE T1 FIELDS TERMINATED BY "," LINES TERMINATED BY "rn";' },
          { title: 'Voir les requêtes en cours d\'exécution', value: 'SHOW FULL PROCESSLIST' }
        ]
      },
      {
        label: 'PHP',
        values: [
          { title: 'Définir le fuseau horaire', value: 'date_default_timezone_set(\'Europe/Paris\');' },
          { title: 'Dernier jour du mois', value: 'strtotime(\'last day of \'.$date)' },
          { title: 'Il y a 1 an', value: 'strtotime(\'last year \'.$date)' },
          { title: 'Calcul de toutes les combinaisons binaires', value: 'define(\'BINARY_LENGTH\', 5 ); <br/> for( $i=0; $i&lt;POW(2,BINARY_LENGTH); $i++ ) { <br/>&nbsp;&nbsp;&nbsp;&nbsp;echo str_pad(decbin($i),BINARY_LENGTH,0,STR_PAD_LEFT).PHP_EOL; <br/> } ' }
        ]
      },
      {
        label: 'Bash',
        values: [
          { title: 'Remplacement de valeur', value: 'sed -i \'s/recherche/remplacement/g\' monfichier.txt' },
          { title: 'Suppression à partir d\'une ligne du fichier', value: 'sed -i ".bk" \'126,$d\' monfichier.txt' },
          { title: 'Supprimer plusieurs lignes dans un fichier', value: 'sed -i \'7,9d\' mon_fichier.txt' },
          { title: 'Rechercher dans des types de fichier donnés', value: 'find . -type f \\( -iname \\*.php -o -iname \\*.html \\) | xargs grep -i "machaine"' },
          { title: 'Décompresser un .tar.gz', value: 'tar -xvzf monfichier.tar.gz --exclude="config/config.+\\.inc\\.php" -C /var/www/html/' },
          { title: 'Afficher les erreurs de syntaxe PHP de tous les fichiers', value: 'find . -type f \\( -iname \\*.php -o -iname \\*.html \\) | while read filename; do php -l $filename | grep -v \'No syntax errors detected in\'; done' },
          { title: 'Manipulation des chaînes de caractères', value: '<a href="https://abs.traduc.org/abs-5.0-fr/ch09s02.html">lien</a>' },
          { title: 'Commande awk', value: '<a href="http://www.shellunix.com/awk.html">lien</a>' }
        ]
      },
      {
        label: 'HTML',
        values: [
          { title: 'Nom des couleurs', value: '<a href="https://htmlcolorcodes.com/color-names/">lien</a>' },
          { title: 'Caractères HTML', value: '<a href="http://www.toutimages.com/codes_caracteres.htm">lien</a>' },
          { title: 'Flexbox', value: '<a href="https://css-tricks.com/snippets/css/a-guide-to-flexbox/">lien</a>' }
        ]
      },
      {
        label: 'VueJS',
        values: [
          { title: 'Eviter les parseInt() avec le 2-way databinding', value: 'v-model.<strong>number</strong>="maProp"' },
          { title: 'Forcer le re-rendering', value: 'via incrémentation de l\'attribut "key". <a href="https://michaelnthiessen.com/force-re-render/#the-best-way-key-changing">Lien</a>'}
        ]
      }
    ]
  }),
}
</script>